import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45retour_45global from "/vercel/path0/middleware/01.retour.global.js";
import _02_45exists_45in_45cms_45global from "/vercel/path0/middleware/02.existsInCms.global.js";
import app_45shell_45global from "/vercel/path0/middleware/appShell.global.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45retour_45global,
  _02_45exists_45in_45cms_45global,
  app_45shell_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/vercel/path0/middleware/auth.js"),
  "flush-datalayer": () => import("/vercel/path0/middleware/flushDatalayer.js")
}